import { Component, OnInit } from '@angular/core';
import {FormsService} from '../shared/services/databaseServices/forms/forms.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FileService} from '../shared/services/fileService/file.service';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {EmailTableService} from '../shared/services/databaseServices/emailTable/email-table.service';
import {RacerService} from '../shared/services/databaseServices/racer/racer.service';
import {LocalStorageService} from '../shared/services/localStorageService/local-storage.service';
import {DatePipe} from '@angular/common';
import {EmailService} from '../shared/services/emailService/email.service';
import {MatDialog} from '@angular/material';
import {FioService} from '../shared/services/databaseServices/fioService/fio.service';
import {FormBuilder} from '@angular/forms';
import {VoucherService} from '../shared/services/voucher/voucher.service';
import {Voucher} from '../shared/classes/Voucher';
import {BaseDatabaseService} from '../shared/services/databaseServices/BaseDatabaseService';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.css'],
  providers: [DatePipe]
})
export class VoucherComponent implements OnInit {

  vouchers: Voucher[] = undefined;

  id;
  isNew = false;
  emptyForm = this.formBuilder.group({});
  plusButton = true;
  editButton = false;
  createTooltip = 'raceDetailPage.voucherTab.saveToolTip';
  deleteTooltip = 'raceDetailPage.voucherTab.deleteToolTip';
  addTooltip = 'raceDetailPage.voucherTab.addToolTip';

  displayedColumns: string[] = ['keyword', 'value', 'type', 'date', 'pieces'];

  header = [
    {
      defName: 'keyword',
      translation: 'raceDetailPage.voucherTab.tab.keyword',
      elem: 'keyword'
    },
    {
      defName: 'value',
      translation: 'raceDetailPage.voucherTab.tab.value',
      elem: 'value'
    },
    {
      defName: 'type',
      translation: 'raceDetailPage.voucherTab.tab.type',
      elem: 'type'
    },
    {
      defName: 'date',
      translation: 'raceDetailPage.voucherTab.tab.date',
      elem: 'date'
    },
    {
      defName: 'pieces',
      translation: 'raceDetailPage.voucherTab.tab.pieces',
      elem: 'pieces'
    }
  ];

  constructor(private formsService: FormsService,
              private activatedRoute: ActivatedRoute,
              private fileService: FileService,
              private voucherService: VoucherService,
              private racesService: RacesService,
              private emailTableService: EmailTableService,
              private racerService: RacerService,
              private router: Router,
              private datePipe: DatePipe,
              private localStorageService: LocalStorageService,
              private emailService: EmailService,
              public dialog: MatDialog,
              private fioService: FioService,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.loadVoucherByRace();
  }

  loadVoucherByRace() {
    this.vouchers = [];
    this.voucherService.readOne(this.id).then(data => {
      this.vouchers = data.data().vouchers;
      let index = 0;
      this.vouchers.forEach(v => {
        v.id = index;
        try {
          v.date = this.datePipe.transform(v.date, 'dd.MM.yyyy HH:mm');
        } catch (e) {
          console.log(e);
        }
        index++;
      });
      this.voucherService.vouchers = this.vouchers;
      console.dir(this.vouchers);
    })
  }

  private createDate(date: string) {
    const d: string[] = date.split(' ');
    const d0 = d[0].split('.');
    const toTranslate = `${d0[2]}/${d0[1]}/${d0[0]} ${d[1]}`;
    return new Date(toTranslate);
  }

  save(item) {
  }

  delete(item) {
  }

  add(item) {
    this.voucherService.editVoucherId = -1;
    this.router.navigate(['/admin/races/voucherDetail', this.id]);
  }

  edit(item) {
    this.voucherService.editVoucherId = item.id;
    this.router.navigate(['/admin/races/voucherDetail', this.id]);
  }

}
